<template>
    <div>
        <Header :headerData="headerData"></Header>

        <div class="query_box" >
            <SearchForm
                ref="searchFormRef"
                :tenantOptions="tenantOptions"
                @handleInputChange="handleInputChange"
                @handleSearch="handleSearch"
                @handleSelectChange="handleSelectChange"
            ></SearchForm>
        </div>

        <!-- <div class="operate_btn">
            <a-button type="primary" size="small" style="margin-right:10px;margin-bottom:10px" @click="handle('uploadFirmware')">
                <UploadOutlined />
                {{ $t('firmware.uploadFirmware') }}
            </a-button>
        </div> -->

        <div>
            <Table
                class="table"
                :table="table"
                @handleChangePagination="handleChangePagination"
            >
                <!-- 父表格操作按钮 -->
                <template v-slot:tableAction="{props}">
                    <template v-if="props.column.key === 'action'">
                        <a-button type="primary" size="small" :disabled="props.record.disabled" style="margin-right:10px" @click="handle('download',props.record)">
                            <a-tooltip placement="top">
                                <template #title>
                                    <span>{{$t('base.download')}}</span>
                                </template>
                                <component :is="$antIcons['DownloadOutlined']"></component>
                            </a-tooltip>
                        </a-button>
                        <a-button type="primary" size="small" ghost :disabled="props.record.status_val == 2" style="margin-right:10px" @click="handle('forbidden',props.record)">
                            <a-tooltip placement="top">
                                <template #title>
                                    <span>{{$t('base.forbidden')}}</span>
                                </template>
                                <component :is="$antIcons['StopOutlined']"></component>
                            </a-tooltip>
                        </a-button>
                        <a-button size="small" :disabled="props.record.disabled" @click="handle('edit',props.record)">
                            <a-tooltip placement="top">
                                <template #title>
                                    <span>{{$t('base.edit')}}</span>
                                </template>
                                <component :is="$antIcons['EditOutlined']"></component>
                            </a-tooltip>
                        </a-button>
                    </template>
                </template>

                <!-- 子表格操作按钮 -->
                <template v-slot:childTableAction="{props}">
                    <template v-if="props.column.key === 'action'">
                        <a-button type="primary" ghost size="small" :disabled="props.record.disabled" @click="handle('deletePart',props.record)">{{$t('access.deletePart')}}</a-button>
                    </template>
                </template>
            </Table>    
        </div>

        <!-- 上传固件 -->
        <UploadFirmware :visible="visible" :isEdit="isEdit" :rowData="rowData" @handleCancel="handleCancel"></UploadFirmware>

    </div>
</template>

<script setup>
    import { onMounted, ref, reactive, createVNode, nextTick, watch} from "vue";
    import Table from "@/components/Table.vue";
    import Card from "@/components/Card.vue";
    import Header from "@/layouts/component/Header.vue";
    import SearchForm from "./SearchForm.vue";
    import UploadFirmware from "./UploadFirmware.vue";
    import { useRoute, useRouter } from "vue-router";
    import { useI18n } from 'vue-i18n';
    import { message, Modal, notification } from 'ant-design-vue';
    import { getWeek } from '@/hooks/useGetWeek';
    import { getLastWeekDate, getFieldVal } from '@/utils/global';
    import { FirmwareApi } from '@/api/FirmwareApi.js';
    import { AdvancedFunApi } from '@/api/AdvancedFunApi.js';
    import { ExclamationCircleOutlined } from '@ant-design/icons-vue';


    const route = useRoute()
    const router = useRouter()
    const { t } = useI18n()

    const userInfo = ref(JSON.parse(sessionStorage.getItem('userInfo')))
    const visible = ref(false)
    const searchFormRef = ref(null)
    const isEdit = ref(false)
    const rowData = ref({})
    const tenantObj = reactive({})
    const tenantOptions = ref([])
    

    const headerData = ref({
        menu:'menu.FirmwareList',
        menu_desc: 'menu.subFirmware',
        week: getWeek().week,
        current_time: getWeek().currentDate,
    })

    const table = ref({
        data: [],
        columns: [
            // {
            //     title: t('firmware.order_number'),//'序号'
            //     dataIndex: 'order_number',
            //     key: 'order_number',
            //     width: 70,
            //     resizable: true,
            //     fixed: 'left',
            // },
            {
                title: t('account.tenant'),//'租户'
                key: 'sys_org',
                dataIndex: 'sys_org',
                width: 110,
                resizable: true,
                fixed: 'left',
            },
            {
                title: t('firmware.file_name'),//'项目编号'
                dataIndex: 'file_name',
                key: 'file_name',
                width: 240,
                ellipsis: true,
                resizable: true,
            },
            // {
            //     title: t('firmware.company_id'),//'公司ID'
            //     dataIndex: 'company_id',
            //     key: 'company_id',
            //     width: 120,
            //     resizable: true,
            // },
            // {
            //     title: t('firmware.part_no'),//'部件编号'
            //     dataIndex: 'part_no',
            //     key: 'part_no',
            //     width: 100,
            //     ellipsis: true,
            //     resizable: true,
            // },
            {
                title: t('firmware.hardware_version'),//'硬件版本'
                dataIndex: 'hardware_version',
                key: 'hardware_version',
                width: 150,
                resizable: true,
            },
            {
                title: t('firmware.software_version'),//'软件版本'
                dataIndex: 'software_version',
                key: 'software_version',
                width: 150,
                ellipsis: true,
            },
            {
                title: t('firmware.firmwareStatus'),//'固件状态'
                key: 'status',
                dataIndex: 'status',
                width: 150,
                resizable: true,
            },
            {
                title: t('firmware.environment'),//'发布环境'
                key: 'environment',
                dataIndex: 'environment',
                width: 200,
                resizable: true,
            },
            {
                title: t('firmware.release_limit'),//'发布限制'
                key: 'release_limit',
                dataIndex: 'release_limit',
                width: 140,
                resizable: true,
            },
            {
                title: t('firmware.release_limit_val'),//'限制具体值'
                key: 'release_limit_val',
                dataIndex: 'release_limit_val',
                width: 200,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('firmware.file_size'),//'文件大小'
                key: 'file_size',
                dataIndex: 'file_size',
                width: 110,
            },
            {
                title: t('firmware.firmware_desc'),//'固件描述（英）'
                key: 'firmware_desc',
                dataIndex: 'firmware_desc',
                width: 250,
                resizable: true,
                ellipsis: { showTitle: true },
            },
            {
                title: t('firmware.firmware_desc_de'),//'固件描述（德）'
                key: 'firmware_desc_de',
                dataIndex: 'firmware_desc_de',
                width: 250,
                resizable: true,
                ellipsis: { showTitle: true },
            },
            {
                title: t('firmware.firmware_desc_fr'),//'固件描述（法）'
                key: 'firmware_desc_fr',
                dataIndex: 'firmware_desc_fr',
                width: 250,
                resizable: true,
                ellipsis: { showTitle: true },
            },
            {
                title: t('firmware.firmware_desc_nl'),//'固件描述（荷兰）'
                key: 'firmware_desc_nl',
                dataIndex: 'firmware_desc_nl',
                width: 250,
                resizable: true,
                ellipsis: { showTitle: true },
            },
            {
                title: t('firmware.firmware_desc_et'),//'固件描述（爱沙尼亚）'
                key: 'firmware_desc_et',
                dataIndex: 'firmware_desc_et',
                width: 250,
                resizable: true,
                ellipsis: { showTitle: true },
            },
            {
                title: t('firmware.firmware_desc_lv'),//'固件描述（拉脱维亚）'
                key: 'firmware_desc_lv',
                dataIndex: 'firmware_desc_lv',
                width: 250,
                resizable: true,
                ellipsis: { showTitle: true },
            },
            {
                title: t('firmware.firmware_desc_lt'),//'固件描述（立陶宛）'
                key: 'firmware_desc_lt',
                dataIndex: 'firmware_desc_lt',
                width: 250,
                resizable: true,
                ellipsis: { showTitle: true },
            },
            {
                title: t('firmware.creator'),//'创建者'
                key: 'creator',
                dataIndex: 'creator',
                width: 200,
                resizable: true,
            },
            {
                title: t('firmware.create_time'),//'创建时间'
                key: 'create_time',
                dataIndex: 'create_time',
                width: 180,
                resizable: true,
            },
            {
                title: t('firmware.terminate_time'),//'废止时间'
                key: 'terminate_time',
                dataIndex: 'terminate_time',
                width: 180,
                resizable: true,
            },
            {
                title: t('base.operate'),//'操作'
                key: 'action',
                fixed: 'right',
                width: 150,
                resizable: true,
            },
        ],
        configs: {
            table: {
                rowClassName:(record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                x: 1800,
                y: 550,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: false,
            pagination:{
                hideOnSinglePage:false,
                position:['bottomLeft'],
                responsive:true,// size 未指定时，根据屏幕宽度自动调整尺寸
                current:1,
                pageSize:10,
                pageSizeOptions:['10','20','50'],
                total:0,
                // showTotal:()=>t('base.total') + ` ${table.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })

    const handleInputChange = (formData) => {
        table.value.configs.pagination.current = 1
        getList()
    }
    const handleSearch = (formData) => {
        table.value.configs.pagination.current = 1
        getList()
    }
    const handleSelectChange = (formData) => {
        table.value.configs.pagination.current = 1
        getList()
    }

    // 分页
    const handleChangePagination = (config, data) => {
        table.value.configs.pagination.current = config.current
        table.value.configs.pagination.pageSize = config.pageSize
        getList()
    }

    // 表格操作
    const handle = (type, row) => {
        switch (type) {
            case 'uploadFirmware': // 上传固件
                visible.value = true
                isEdit.value = false
                break;
            case 'download':
                row.disabled = true
                message.success(t('base.downloading'))
                table.value.configs.loading = true
                let token = sessionStorage.getItem('token')
                let url = `${row.download_path}?Authorization=Bearer ${token}`
                let a = document.createElement('a')
                a.href = url
                a.style.display = 'none'
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
                setTimeout(()=>{
                    row.disabled = false
                    table.value.configs.loading = false
                },1500)
                break;
            case 'forbidden': // 禁用
                Modal.confirm({
                    title: t('firmware.deleteMsg'),
                    icon: createVNode(ExclamationCircleOutlined),
                    okText: t('base.yes'),
                    cancelText: t('base.no'),
                    onOk() {
                        forbiddenFirmware(row.id)
                    },
                });
                break;
            case 'edit': // 编辑
                isEdit.value = true
                visible.value = true
                rowData.value = row
                break;
        }
    }

    const handleCancel = () => {
        visible.value = false
        getList()
    }

    // 获取固件列表
    const getList = async() => {
        let param = {
            ...searchFormRef.value.formData,
            project_no: searchFormRef.value.formData.project_no.trim(),
            company_id: searchFormRef.value.formData.company_id.trim(),
            part_no: searchFormRef.value.formData.part_no.trim(),
            hardware_version: searchFormRef.value.formData.hardware_version.trim(),
            software_version: searchFormRef.value.formData.software_version.trim(),
            sys_org: userInfo.value.tenant_id != 1 ? userInfo.value.tenant_id : searchFormRef.value.formData.sys_org
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize

        table.value.configs.loading = true
        let res = await FirmwareApi.getInstance().getFirmwareList(param, page_num, page_size)
        if (res.code == 0) {
            let data = res.data
            data.records.forEach((i, index) => {
                i.order_number = index + 1
                i.status_val = i.status
                i.status = i.status_val == 0 ? t('firmware.published') : i.status_val == 1 ? t('firmware.testing') : t('firmware.not_used')
                i.environment_val = i.environment
                i.environment = i.environment_val == 0 ? t('firmware.market_environment') : i.environment_val == 1 ? t('firmware.testing_environment') : t('firmware.production_environment')
                i.release_limit_data = i.release_limit,
                i.release_limit = i.release_limit_data == 0 ? t('firmware.unlimited') : i.release_limit_data == 1 ? t('firmware.base') : i.release_limit_data == 2 ? t('firmware.grayscale') : i.release_limit_data == 3 ? t('firmware.personal') : i.release_limit_data == 5 ? t('firmware.frameNumber') :(i.release_limit_data == 6 ? t('firmware.sku') : t('firmware.assemblyCode')) 
                i.file_size = Number(i.file_size / 1024).toFixed(1) + ` KB`,
                i.terminate_time = i.terminate_time == undefined? '-' : i.terminate_time,
                i.release_limit_val = i.release_limit_val == undefined || i.release_limit_val == ''? '-' : i.release_limit_val
                i.firmware_desc = i.file_desc == undefined? '-' : i.file_desc
                i.firmware_desc_de = !i.file_desc_de? '-' : i.file_desc_de
                i.firmware_desc_fr = !i.file_desc_fr? '-' : i.file_desc_fr
                i.firmware_desc_nl = !i.file_desc_nl? '-' : i.file_desc_nl
                i.firmware_desc_et = !i.file_desc_et? '-' : i.file_desc_et
                i.firmware_desc_lv = !i.file_desc_lv? '-' : i.file_desc_lv
                i.firmware_desc_lt = !i.file_desc_lt? '-' : i.file_desc_lt
                // i.sys_org = i.sys_org == undefined? '-' : i.sys_org == 0? t('base.HEPHA') : i.sys_org == 6? t('base.corest') : i.sys_org == 9? t('base.birk') : t('base.GOBAO')
                i.sys_org = i.sys_org == undefined? '-' : tenantObj[i.sys_org]
            })
            table.value.configs.pagination.total = data.total
            table.value.configs.pagination.current = data.current
            table.value.data = data.records

            table.value.configs.loading = false
        } else {
            message.error(res.msg);
        }
    }


    // 禁用固件
    const forbiddenFirmware = async (id) => {
        let res = await FirmwareApi.getInstance().forbiddenFirmware(id)
        if (res.code == 0) {
            message.success(t('firmware.forbiddenMsg'))
            getList()
        } else {
            message.error(res.msg)
        }
    }

     // 获取租户列表
     const getTenantList = async()=>{
        let param = {
            limit_size: 100,
        }
        let res = await AdvancedFunApi.getInstance().getAllTenant2(param)
        if(res.code === 0){
            res.data.forEach(i=>{
                tenantObj[i.tenant_id] = i.tenant_name
            })

            tenantOptions.value = res.data.map(item => ({
                label: item.tenant_name,
                value: item.tenant_id,
            }))
            tenantOptions.value.unshift({
                label: t('access.allTenant'),
                value: null,
            })
        }
    }

    onMounted(async () => {
        await getTenantList()
        getList()
    })

</script>

<style lang="scss" scoped>
::v-deep .ant-table-wrapper .ant-table-thead>tr>th, 
::v-deep .ant-table-wrapper .ant-table-tbody>tr>td, 
::v-deep .ant-table-wrapper tfoot>tr>td{
    padding: 6px 16px;
}

// 子表格的表体行样式
::v-deep .subTableBg{
    background: #f6f6f6 !important;
}

::v-deep .page_header .week{
    margin-top: -55px;
    transform: translateY(8px);
}
::v-deep .page_header .admin_email{
    margin-top: -55px;
    transform: translateY(18px);
}

// 当sub不为空时
// ::v-deep .page_header .week{
//     margin-top: -70px;
// }
// ::v-deep .page_header .admin_email{
//     margin-top: -60px;
// }
</style>